import React from 'react';
import styles from './Footer.module.scss';
import Logo from '../Icons/Logo';
import Navigation from './Navigation/Navigation';
import MobileNavigation from './MobileNavigation/MobileNavigation';
import SocialNetworks from './SocialNetworks/SocialNetworks';
import { ROUTE_NAMES } from '../../../contstants/route';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'usehooks-ts';
import cn from 'classnames';

export default function Footer(data) {
  console.log(data, '//////////**');
  let carModel = false;
  const location = useLocation();
  console.log(location, '***************');
  const isMobile = useMediaQuery('(max-width: 480px)');
  if (
    (location.pathname.includes('JAECOO-7-SHS') || location.pathname.includes('OMODA-9-SHS')) &&
    isMobile
  ) {
    carModel = true;
  }
  return (
    <footer
      className={carModel ? cn(styles.footer, styles.footer_car_model) : styles.footer}
      data-aos="fade-up"
    >
      <div className="container">
        <div className={styles.footer_inner}>
          <div className={styles.footer_inner_top}>
            <div className={styles.footer_inner_top_textBlock}>
              <a href={data?.fields?.logoUrl?.value?.href || '/'}>
                <Logo color="#fff" />
              </a>
              <RichText
                field={data.fields.Description}
                className={styles.footer_inner_top_text}
              ></RichText>
            </div>
          </div>
          <div className={styles.footer_inner_socialNetworksMobile}>
            <SocialNetworks />
            <div className={styles.footer_inner_top_phone}>
              <div>{data.fields.PhoneTitle?.value || data.fields.PhoneTitle}</div>
              <a href={'tel:' + data.fields.Phone.value.replace(' ', '')}>
                {data.fields.Phone.value}
              </a>
            </div>
          </div>
          <Navigation menuInfo={data.fields.menu} />
          <MobileNavigation menuInfo={data.fields.menu} />
          <div className={styles.footer_inner_socialNetworks}>
            <SocialNetworks />
            <div className={styles.footer_inner_top_phone}>
              <div>{data.fields.PhoneTitle?.value || data.fields.PhoneTitle}</div>
              <a href={'tel:' + data.fields.Phone.value.replace(' ', '')}>
                {data.fields.Phone.value}
              </a>
            </div>
          </div>
          <div className={styles.footer_inner_line} />
          <div className={styles.footer_inner_bottom}>
            <p className={styles.footer_inner_bottom_copyright}>{data.fields.Copyright.value}</p>
            <ul className={styles.footer_inner_bottom_list}>
              {/* <li className={styles.footer_inner_bottom_list_item}>*/}
              {/*  <a href="/">Legal Notice</a>*/}
              {/* </li>*/}
              {data?.fields?.LegalLinks.map((item) => (
                <li className={styles.footer_inner_bottom_list_item} key={item?.id}>
                  <a href={item?.fields?.url?.value?.href}>{item?.fields?.name?.value}</a>
                </li>
              ))}
              {/* <li className={styles.footer_inner_bottom_list_item}> */}
              {/*   <a href={ROUTE_NAMES.privacyPolicy}>Privacy Policy</a> */}
              {/* </li> */}
              {/* <li className={styles.footer_inner_bottom_list_item}> */}
              {/*   <a href={ROUTE_NAMES.cookiesPolicy}>Cookie Notice</a> */}
              {/* </li> */}
              {/* <li className={styles.footer_inner_bottom_list_item}>*/}
              {/*  <a href={ROUTE_NAMES.EPCROfficialAutomotivePartner}>Terms and Conditions</a>*/}
              {/* </li>*/}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
